import React from "react";
import { withRouter } from 'react-router-dom';
import AccountBanner from "../../components/AccountBanner"
import RedirectFailureAlarms from "./RedirectFailureAlarms";
import DailySpikeAlarms from "./DailySpikeAlarms";
import SalesDailySpikeAlarms from "./SalesDailySpikeAlarms"
import WeeklyLinkSpikeAlarms from "./WeeklyLinkSpikeAlarms"
import LinksLowEngagementAlarms from "./LinksLowEngagementAlarms"
import ClicksToSalesHighLowSpikesAlarms from "./ClicksToSalesHighLowSpikesAlarms";
import MerchantAffiliateProgramManagerAutoShutoffAlarms from "./MerchantAffiliateProgramManagerAutoShutoffAlarms";
import { getQueryStringParams } from "sharedUtils/navUtils"

class Alarms extends React.Component {

    state = {
        selectedCase: 1,
    }

    breadCrumbList = [{ link: '/Admin', text: 'Admin' }, { link: '/Admin/Alarms', text: 'Alarms' }];
    redirectFailuresBreadCrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Redirect Failures', active: true },
    ];

    dailySpikesBreadCrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Clicks Daily Spikes', active: true }
    ];

    salesDailySpikesBreadCrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Sales Daily Spikes', active: true }
    ];

    weeklyLinkSpikesBreadCrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Weekly Link Spikes', active: true }
    ];

    LinksLowEngagementBreadCrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Links Low Engagement', active: true }
    ];

    ClicksToSalesHighLowBreadcrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Sales To Clicks', active: true }
    ];

    BrandsAutoShutoffBreadcrumbList = [
        ...this.breadCrumbList,
        { link: '/Admin/Alarms', text: 'Brands Auto Shutoff', active: true }
    ];

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
        window.scrollTo(scrollOptions);

        const params = getQueryStringParams(window.location.search);
        const selectedCase = Math.floor(params.tab);
        console.log(params, selectedCase)
        if (selectedCase) {
            this.setState({ selectedCase });
        }
    }

    displayToggleButtons = () => {
        let options = [
            {
                name: "Redirect Failures",
                case: 1,
                action: () => this.handleButtonAction(1)
            },
            {
                name: "Clicks Daily Spikes",
                case: 2,
                action: () => this.handleButtonAction(2)
            },
            {
                name: "Sales Daily Spikes",
                case: 3,
                action: () => this.handleButtonAction(3)
            },
            {
                name: "Weekly Link Spikes",
                case: 4,
                action: () => this.handleButtonAction(4)
            },
            {
                name: "Links Low Engagement",
                case: 5,
                action: () => this.handleButtonAction(5)
            },
            {
                name: "Sales To Clicks",
                case: 6,
                action: () => this.handleButtonAction(6)
            },
            {
                name: "Brands Auto Shutoff",
                case: 7,
                action: () => this.handleButtonAction(7)
            },
        ];

        return options.map((toggle, i) => {
            return (
                <button key={i}
                    className={`btn ${this.state.selectedCase === toggle.case ? "btn-primary btn-lg" : ""}`}
                    onClick={toggle.action}
                >
                    {toggle.name}
                </button>
            )
        })
    }

    handleButtonAction = selectedCase => {
        this.setState({ selectedCase });
        this.updateQueryString(selectedCase);
    }

    updateQueryString = (tab) => {
        const { history } = this.props;

        // Build the new search string with updated query parameters
        const newSearch = `?tab=${tab}`;

        // Use history.replace to update the URL without adding a new entry to the history stack
        history.replace({
            search: newSearch,
        });
    };

    getBreadCrumbList = () => {
        switch (this.state.selectedCase) {
            case 1: return this.redirectFailuresBreadCrumbList;
            case 2: return this.dailySpikesBreadCrumbList;
            case 3: return this.salesDailySpikesBreadCrumbList;
            case 4: return this.weeklyLinkSpikesBreadCrumbList;
            case 5: return this.LinksLowEngagementBreadCrumbList;
            case 6: return this.ClicksToSalesHighLowBreadcrumbList;
            case 7: return this.BrandsAutoShutoffBreadcrumbList;
            default: return this.breadCrumbList;
        }
    };

    render() {
        return (
            <>
                <section>
                    <AccountBanner breadCrumbList={this.getBreadCrumbList()}>
                        <h1 className="mb-4">Alarms</h1>
                        <p className="mb-0">Management of system alarms and alerts</p>
                    </AccountBanner>
                </section>
                <section className="filter-wrapper" >
                    <div className="container">
                        <div className="row py-2 mt-0">
                            <div className="col-12 d-flex justify-content-between">
                                <div className="d-flex justify-content-around" style={{ flexWrap: "wrap" }} >
                                    {this.displayToggleButtons()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="gray-bg full-height pt-1">
                    <RedirectFailureAlarms
                        display={this.state.selectedCase === 1}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <DailySpikeAlarms
                        display={this.state.selectedCase === 2}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <SalesDailySpikeAlarms
                        display={this.state.selectedCase === 3}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <WeeklyLinkSpikeAlarms
                        display={this.state.selectedCase === 4}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <LinksLowEngagementAlarms
                        display={this.state.selectedCase === 5}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <ClicksToSalesHighLowSpikesAlarms
                        display={this.state.selectedCase === 6}
                        loggedInUser={this.props.loggedInUser}
                    />
                    <MerchantAffiliateProgramManagerAutoShutoffAlarms
                        display={this.state.selectedCase === 7}
                        loggedInUser={this.props.loggedInUser}
                    />
                </section>
            </>
        )
    }
}

export default withRouter(Alarms);